import { render } from "./TableLoader.vue?vue&type=template&id=356feda3"
import script from "./TableLoader.vue?vue&type=script&lang=js"
export * from "./TableLoader.vue?vue&type=script&lang=js"

import "./TableLoader.vue?vue&type=style&index=0&id=356feda3&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__